<template>
  <mia-modal
    id="vti-pickup-modal"
    classes="v--modal flex flex-col"
    width="40%"
    height="auto"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <mia-modal-header>
      <h3 class="py-0 my-0">
        VTI Abholung
      </h3>
    </mia-modal-header>

    <div class="p-4">
      <p>Sind Sie sicher, dass das Fahrzeug vom Transportunternehmen abgeholt wurde und die Leasingrückgabe vollständig abgeschlossen ist?</p>
      <div class="mt-4">
        <mia-feature-input
          v-model="form.finishedAt"
          label="Wann wurde das Fahrzeug abgeholt?"
          :errors="getErrors('item_finished_at')"
          required
          type="date"
          @input="clearErrors('item_finished_at')"
        />
      </div>
    </div>

    <mia-modal-footer class="flex items-center justify-end space-x-3">
      <mia-cancel-button
        label="Abbrechen"
        @click="$emit('closed')"
      />
      <mia-submit-button
        label="VTI abgeholt"
        :disabled="!isValid || $wait.any"
        :is-loading="$wait.is('updating vti status')"
        type="button"
        @click="onSubmit"
      />
    </mia-modal-footer>
  </mia-modal>
</template>

<script>
import { DateTime } from 'luxon'
import { pickupVti } from '@/api/cars'
import CancelButton from '@/components/cars/edit/CancelButton.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import FeatureInput from '@/components/cars/edit/FeatureInput.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'

export default {
  name: 'VtiPickupModal',

  components: {
    'mia-cancel-button': CancelButton,
    'mia-feature-input': FeatureInput,
    'mia-submit-button': SubmitButton
  },

  mixins: [HandlesBackendValidationErrors],

  props: {
    carId: {
      type: [String, Number],
      required: true,
      validator: value => parseInt(value, 10) > 0
    }
  },

  data: () => ({
    form: {
      finishedAt: ''
    }
  }),

  computed: {
    isValid() {
      return this.form.finishedAt !== ''
    }
  },

  created() {
    this.form.finishedAt = DateTime.local().toFormat('yyyy-MM-dd')
  },

  methods: {
    async onSubmit() {
      this.$wait.start('updating vti status')
      const [errors] = await pickupVti(this.carId, {
        item_finished_at: this.form.finishedAt
      })
      this.$wait.end('updating vti status')

      if (errors) {
        this.handleBackendValidationErrors(errors)

        window.eventBus.$emit('mia-error', {
          error: ['Fehler beim Speichern der Daten.']
        })

        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['VTI erfolgreich abgeholt.']
      })

      this.$emit('vti-finished')
    }
  }
}
</script>
